import React, { useState } from "react";
import { Box, Divider, Tab, Tabs, Typography, makeStyles } from "@material-ui/core";
import InventoryDiagnostics from "./InventoryDiagnostics";
import Reconciliation from "../reconciliation/Reconciliation";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) }
  },
  heading: { fontWeight: 700, marginBottom: theme.spacing(2) },
  tabs: { marginBottom: theme.spacing(3) }
}));

export default function InventoryDiagnosticsPage() {
  const classes = useStyles();
  const [tab, setTab] = useState("diagnostics");
  const [hasOpenedReconciliation, setHasOpenedReconciliation] = useState(false);

  function changeTab(event, value) {
    setTab(value);
    if (value === "reconciliation") setHasOpenedReconciliation(true);
  }

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.heading}>Inventory Diagnose</Typography>
      <Box className={classes.tabs}>
        <Tabs value={tab} onChange={changeTab} indicatorColor="primary" textColor="primary"
          variant="scrollable" scrollButtons="auto" aria-label="Inventory Diagnose Bereiche">
          <Tab value="diagnostics" label="Bestandsdiagnose" id="inventory-diagnostics-tab"
            aria-controls="inventory-diagnostics-panel" />
          <Tab value="reconciliation" label="LIMES–Shop-Abgleich" id="inventory-reconciliation-tab"
            aria-controls="inventory-reconciliation-panel" />
        </Tabs>
        <Divider />
      </Box>
      <Box role="tabpanel" id="inventory-diagnostics-panel" aria-labelledby="inventory-diagnostics-tab"
        hidden={tab !== "diagnostics"}>
        <InventoryDiagnostics isActive={tab === "diagnostics"} />
      </Box>
      <Box role="tabpanel" id="inventory-reconciliation-panel" aria-labelledby="inventory-reconciliation-tab"
        hidden={tab !== "reconciliation"}>
        {hasOpenedReconciliation && <Reconciliation isActive={tab === "reconciliation"} />}
      </Box>
    </Box>
  );
}
